export default {
  categoryInfo: {
    mainTitle: 'Konut Sigortası (Ev Sigortası)',
    description: {
      title: 'Konut Sigortası (Ev Sigortası) Nedir?',
      content: [
        'Eviniz, başınızın üzerinde bir çatıdan daha fazlasıdır. Bu sizin en değerli varlığınız olabilir ve bir felaket meydana gelirse muhtemelen cebinizden sigortaya ödemeniz gereken bütçeden daha fazlası çıkar. Bu nedenle yatırımınızı doğru ev sigortası ile korumak çok önemlidir.',
        'Konut sigortası, evinizde doğal afet veya kazaen oluşacak hasarlara karşı güvence sağlayarak, maddi kayıpları teminat altına almaktadır. Ev sigortası, kapsam dâhilindeki bir olay evinize, mülkünüze veya kişisel eşyalarınıza zarar verirse maddi yardım sağlar.',
        'Konut sigortası sadece sigortalı evi değil komşuların uğrayabileceği hasarları da teminat altına alabilir. Bu poliçe kapsamına seçeceğiniz teminatlar ile alakalıdır. '
      ]
    },
    subContent: {
      title: 'Konut Sigortası Teminatları Nelerdir?',
      content: [
        {
          paragraph:
            'Konut sigortası teminatları sigorta şirketine ve sigortalanın talebine göre değişiklik göstermektedir. Konut sigortası ile neleri kapsam altına alabilirsiniz? Kısaca öğrenebilirsiniz;',
          subList: null
        },
        {
          paragraph: '<strong>Konut Sigortası Ana Teminatları;</strong>',
          subList: [
            'Cam Kırılması',
            'Deprem',
            'Enkaz Kaldırma Giderleri',
            'Ferdi Kaza',
            'Fırtına',
            'Hırsızlık',
            'Sel Ve Su Baskını',
            'Yanardağ Püskürmesi',
            'Yardım Hizmetlerini Kapsamaktadır.'
          ]
        }
      ]
    }
  },
  faqTitle: 'Sıkça Sorulan Sorular',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: [
    {
      title: 'Konut Sigortası Ek Teminatları Nelerdir?',
      content: [
        {
          paragraph: null,
          subList: [
            '3.Şahıs Sorumluluk',
            'Dolu hasarları',
            'Elektronik Cihazlar',
            'Enkaz Kaldırma',
            'İzolasyon Eksikliği',
            'Kar Ağırlığı',
            'Kıymetli Eşya Hırsızlık',
            'Yakıt Sızması',
            'Yangın Mali Sorumluluk',
            'Yer Kayması Hasarların Kapsamaktadır.'
          ]
        }
      ]
    },
    {
      title: 'Eşya Sigortası Kapsamı Nedir?',
      content: [
        {
          paragraph:
            'Eşya sigortası evinizde bulunan eşyanın veya eşyaların kazaen hasar görmesi riskine karşı güvence sağlamaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Konut Sigortası Genel Şartları Neden Önemlidir?',
      content: [
        {
          paragraph:
            'Ev sigortası genel şartları tüm sigorta şirketlerinde sabittir. Genel şartlar kapsamında bilgi almanızda sigorta poliçenizi satın alma aşamasında önemlidir. Genel şartlar çerçevesinde hazırlanmış olan maddeler, konut sigortasının kapsamını, kapsam dışı kalan durumları, hasar ödeme şartları gibi birçok konuya değinir. Bu maddelere kısaca göz atmanız poliçe süresi boyunca bir sorun yaşamamanızı sağlar.',
          subList: null
        }
      ]
    },
    {
      title: 'Ne Kadar Ev Sahibi Sigortasına İhtiyacınız Var?',
      content: [
        {
          paragraph:
            'Söz konusu binanız yıkılırsa, evinizi yeniden inşa etmenin maliyetini karşılayacak yeterli ev sigortasına ihtiyacınız vardır. Yeniden inşa maliyetinizi tahmin etmek için, evinizin metrekaresini, metrekare başına yerel inşaat maliyetleriyle çarpın. ',
          subList: null
        },
        {
          paragraph:
            'Kapsamlı bir sigorta poliçesine ihtiyacınız varsa mutlaka eşya teminatını da poliçenize ekleyin. Sigorta uzmanlarımız en iyi teminatları seçmenize yardımcı olacaktır. ',
          subList: null
        }
      ]
    },
    {
      title: 'Konut (Ev) Sigortası Ne Zaman Başlar?',
      content: [
        {
          paragraph:
            'Konut sigortası ödemesi gerçekleştikten sonra poliçeniz aynı gün başlar. ',
          subList: null
        },
        {
          paragraph:
            'Sigorta başlangıç ve bitiş tarihleri poliçenin üzerinde yazmaktadır. Yazan tarihlerde öğlen 12.00’da başlar 12.00’da sonlanır.',
          subList: null
        }
      ]
    },
    {
      title: 'Konut Sigortası İçin Gerekli Bilgiler Nelerdir?',
      content: [
        {
          paragraph:
            'Konut sigortası satın alınırken konuta ve sigortalıya ait birkaç bilgi talep edilir. Bu bilgilerin doğru verilmesi son derece önemlidir. Konut sigortası için gereken bilgiler;',
          subList: [
            'Sigortalı TC veya vergi kimlik numarası',
            'Bina yapı tarzı',
            'Bina brüt metrekaresi',
            'Bina inşa yılı',
            'Binada kaç kat bulunduğu',
            'Dairenin kaçıncı katta olduğu',
            'Bina bedeli',
            'Daire içerisin de bulunan eşyaların bedelleri yazan faturalar',
            'DASK poliçe numarası gerekmektedir.'
          ]
        }
      ]
    },
    {
      title: 'Konut Sigortası DASK Yerine Geçer Mi?',
      content: [
        {
          paragraph: 'Konut sigortası DASK sigortası yerine geçmemektedir. ',
          subList: null
        },
        {
          paragraph:
            'DASK sigortası doğal afet sonucu olun hasarlarda sadece dairenin kaba inşasını karşılamaktadır. Konut sigortası ise almış olduğunuz teminatlara göre evin içerisinde bulunan eşyaları, boya & badana masrafları ve dekorasyon masraflarını karşılamaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Konut Sigortası İle DASK Aynı Mı, Farkları Nelerdir?',
      content: [
        {
          paragraph: 'Konut sigortası ile DASK sigortası aynı değildir.',
          subList: [
            'DASK sigortası zorunlu bir poliçedir. Konut sigortası ise isteğe bağlı olarak yapılmaktadır.',
            'DASK sigortası doğal afet risklerini güvence altına alırken, konut sigortası yangın, hırsızlık ve cam kırılması gibi hasarları karşılar.',
            'DASK primi tüm sigorta şirketlerinde aynıdır, konut sigortası primleri şirketler arasında farklılık göstermektedir.',
            'DASK teminatları tüm sigorta şirketlerinde aynıdır, konut sigortası teminatları şirketler arası ve paketlere göre farklılık göstermektedir.'
          ]
        }
      ]
    },
    {
      title: 'Eşya Sigortası İle Konut Sigortası Arasındaki Fark Nedir?',
      content: [
        {
          paragraph:
            'Eşya sigortası eviniz içerisindeki eşyaları güvence altına alırken konut sigortası dekorasyon, boya ve badana, elektrik tesisatı, su tesisatı, doğalgaz tesisatı hasarlarını güvence altına almaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Konut Sigortası Yaptırırken Nelere Dikkat Etmeliyiz?',
      content: [
        {
          paragraph:
            'Konut sigortası yaptırırken en önemli konu eşya ve konut bedelidir. ',
          subList: null
        },
        {
          paragraph:
            'Ödemeler bedellere göre yapılmaktadır. Bu nedenle bedeller kesin ve doğru olması gerekmektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Konut Sigortası Ne İşe Yarar?',
      content: [
        {
          paragraph:
            'Konut sigortası, meskende oluşabilecek hasarlara karşı koruma sağlamaktadır.',
          subList: null
        },
        {
          paragraph:
            'Konut sigortası ile oluşan hasarları düşük primler ile karşılayabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Bina Bedeli Nedir?',
      content: [
        {
          paragraph:
            'Bina bedeli, dairenin doğal afet veya kazaen yıkılması durumunda tekrardan yapılması için ödenecek tutardır.',
          subList: null
        }
      ]
    },
    {
      title: 'Konut Sigortası Bina Bedeli Hesaplama Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Bina bedeli hesaplaması binanın yapım yılı, brüt metre kare ve bulunduğu konuma göre yapılmaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Eşya Bedeli Nedir?',
      content: [
        {
          paragraph:
            'Eşya bedeli eşyanın faturada yazan tutarını ifade etmektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Konut Sigortası Hasarsızlık İndirimi Nedir?',
      content: [
        {
          paragraph:
            'Konut sigortasında bulunan hasarsızlık indirimi poliçe vadesi boyunca sigortalanan evde hasar oluşmaması durumunda yenileme döneminde verilen indirimi ifade etmektedir. ',
          subList: null
        },
        {
          paragraph:
            'Hasarsızlık indirimi ne kadar fazla ise sigorta primi o kadar düşük olmaktadır. Hasarsız geçen her yıl poliçenizi düzenli yenilemeniz ile sigorta primlerinden büyük oranda avantaj elde edersiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Konut Sigortası Geçerlilik Süresi Ne Kadar?',
      content: [
        {
          paragraph:
            'Konut sigortası geçerlilik süresi, poliçede yazan başlangıç tarihinden itibaren bir yıldır.',
          subList: null
        }
      ]
    },
    {
      title: 'Konut Sigortası Elektronik Eşyayı Karşılar M?',
      content: [
        {
          paragraph:
            'Konut sigortanıza (ECS Elektronik Cihaz) teminatı eklenmeniz durumunda poliçede yazılı olan limitler dâhilinde karşılanmaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Neden Konut Sigortası Yaptırmalıyım?',
      content: [
        {
          paragraph:
            'Konut sigortası ile evinizde veya eşyalarınızda oluşan hasarları karşılayabilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'Ne kadarda önlem alınsa da kaza geliyorum demez, evinizde oluşabilecek zararlara karşı konut sigortası yaptırmalısınız.',
          subList: null
        }
      ]
    },
    {
      title: 'Konut Sigortası Deprem Hasarını Karşılar Mı?',
      content: [
        {
          paragraph:
            'Konut sigortası yalnızca deprem teminatının eklenmesiyle deprem hasarlarını karşılamaktadır. Deprem teminatının eklenebilmesi için Konuta Ait DASK poliçesi olması gerekmektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Konut Sigortası Yaptırmak Zorunlu Mu?',
      content: [
        {
          paragraph:
            'Konut sigortası isteğe bağlı bir sigorta ürünüdür. Yalnız ev ve eşya bedelleri sürekli artış göstermemektedir. Bu nedenle konut sigortası yaptırmak zorunlu olmamasına rağmen uzmanlar tarafından herkesin yaptırması gereken sigorta ürünü olarak görülmektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Konut Sigortası Hizmetleri Nelerdir?',
      content: [
        {
          paragraph:
            'Konut sigortanıza ek olarak sunulan hizmetler şirketlere göre değişmektedir.Örnek olarak verilen hizmetler;',
          subList: [
            'Kombi ve klima bakımı',
            'Çilingir hizmeti',
            'Küçük çaplı su hasarları gibi hizmetleri kapsamaktadır.'
          ]
        }
      ]
    },
    {
      title: 'Konut Kredisinde Konut Sigortası Zorunlu Mu?',
      content: [
        {
          paragraph:
            'Konut kredili alınmış ise banka tarafından konut sigortası yaptırılmak zorundadır. Yalnız kredi çekilen bankadan yaptırılması zorunlu değildir. Daha iyi teminatı daha uygun fiyata bulmak için tüm sigorta şirketlerinin tekliflerini karşılaştırabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title:
        'Elektrik Sigorta Kutusundan Çıkan Yangın Konut Sigortası Tarafından Karşılanır Mı?',
      content: [
        {
          paragraph:
            'Sigorta tanzim edilirken ekleteceğiniz yangın teminatı ile evinizde oluşan yangınları teminat altına almış olacaksınız. Bu teminat ile oluşacak hasarları karşılatabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title:
        'Hırsızlık Sonucu Televizyonum Çalındı Konut Sigortası Tarafından Karşılanır Mı?',
      content: [
        {
          paragraph:
            'Poliçe teminatları arasında hırsızlık teminatı bulunuyorsa, poliçede belirtilmiş olan limit kapsamında karşılanabilir.',
          subList: null
        }
      ]
    },
    {
      title: 'Konut Sigortası Komşuya Verilen Zararı Karşılar Mı?',
      content: [
        {
          paragraph:
            'Poliçe ekleteceğiniz komşuluk mali mesuliyet teminatı ile komşularınızın uğrayacağı zararları konut sigortanızdan karşılayabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Konut Sigortası Cam Kırılmasını Karşılar Mı?',
      content: [
        {
          paragraph:
            'Evet, poliçenizde bulunan cam kırılması teminat limitleri dâhilinde cam hasarlarınızı karşılayabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Konut Sigortası Su Hasarlarını Kapsar Mı?',
      content: [
        {
          paragraph:
            'Su hasarları poliçe teminatlarına eklenmesi durumunda karşılanmaktadır. ',
          subList: null
        },
        {
          paragraph:
            'Sel ve su baskınları bazı poliçelerde evin konumundan dolayı muafiyet uygulanmaktadır. Sigorta poliçesi tanzim ederken konu hakkında danışmanınızdan kapsamlı bilgi talep etmeyi unutmayınız.',
          subList: null
        }
      ]
    },
    {
      title: 'Konut Sigortası Kombi Arızasını Kapsar Mı?',
      content: [
        {
          paragraph:
            'Kombi arızaları sigorta poliçesi kapsamında karşılanmamaktadır. Yalnızca yılda bir defaya mahsus olarak kombi bakımı yapılmaktadır. Bu satın aldığınız sigorta şirketine göre farklılık gösterecektir. Poliçe kapsamında sunulan hizmetleri değerlendirmeli ve kombi hizmeti olup olmadığını kontrol etmelisiniz.',
          subList: null
        },
        {
          paragraph: '<strong>Kombi bakımı hizmetleri;</strong>',
          subList: [
            'Arıza tespiti',
            'Ejantör kontrolü',
            'Elektrik kaçağı kontrolü',
            'Fan kontrolü',
            'Gaz basıncının ölçümlenmesi',
            'Kapağın sökülerek kombide biriken tozun temizlenmesi olarak sınırlandırılmıştır.'
          ]
        }
      ]
    },
    {
      title: 'Konut Sigortası Kira Kaybı Nedir?',
      content: [
        {
          paragraph:
            'Sigorta poliçesinde yer alan hasarlardan dolayı meskenin kullanılamaz hale gelmesi sebebiyle kira kaybı riskine karşı güvence sağlamaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Konut Sigortası Rutubet Hasarını Karşılar Mı?',
      content: [
        {
          paragraph:
            'Konut sigortası yapıldığı tarihten sonra oluşan rutubet hasarları poliçe kapsamında karşılanmaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Konut Sigortası Kiracı Tarafından Yaptırılabilir Mi?',
      content: [
        {
          paragraph:
            'Konut sigortasını sadece ev sahipleri değil kiracılarda yaptırabilmektedir.',
          subList: null
        },
        {
          paragraph:
            'Örneğin; evin içerisinde bulunan eşyalar kiracıya ait olması sebebiyle dâhili veya ihmale bağlı olarak su baskınları olduğunda eşyalarınızın zarar görmesi riskine karşılık güvence altına almış olursunuz.',
          subList: null
        }
      ]
    },
    {
      title: 'Konut Sigortası Hasar Ödemesi Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'açıldıktan sonra eksper yönlendirilir hasar incelemesi yapılarak hasar boyutu ölçülür ekspertiz raporu hazırlanarak şirkete yönlendirilir. ',
          subList: null
        },
        {
          paragraph:
            'Şirket gelen beyan ve raporları kontrol ederek dosyaya onay verir. Hasar durumuna göre hasar tamiri veya ödemesi yapılmaktadır. Bu durum hasarın boyutuna göre değişmektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Konut Sigortası Vergi İndirimi Nedir?',
      content: [
        {
          paragraph: 'Konut sigortası ürününde vergi indirimi bulunmamaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Konut Sigortası Şirketleri Hangileridir?',
      content: [
        {
          paragraph:
            'Alokasko olarak siz değerli müşterilerimizin evini ve eşyalarını koruma altına alabilmek için 18 adet sigorta şirketi ile anlaşmalıyız.',
          subList: null
        },
        {
          paragraph: 'Bu şirketleri aşağıdaki tablodan inceleyebilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Konut Sigortası Hesaplama İşlemi Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Konut sigortası hesaplaması meskenin brüt yüz ölçümü, sigortalı bilgileri, meskenin acık adres bilgileri eğer eklenecekse eşya bedelleri girilerek hesaplama gerçekleşir.',
          subList: null
        }
      ]
    },
    {
      title: 'En İyi (En Uygun ) Konut (Ev) Sigortası Hangisi?',
      content: [
        {
          paragraph:
            'En iyi konut sigortası, sizin talep ettiğiniz teminatları kapsayan sigorta poliçesidir. Taleplerinize cevap veremeyen anlamsız teminatlarla dolu poliçe satın almamaya özen göstermelisiniz.',
          subList: null
        },
        {
          paragraph:
            'Sigorta şirketlerinin sunmuş olduğu teminatların size uygunluğunu incelemeli ve size en uygun ev sigortasını seçmelisiniz. Bunun için çok fazla zaman harcamanıza gerek yok, sigorta danışmanlarımız yanınızda!',
          subList: null
        }
      ]
    },
    {
      title: 'En Ucuz Konut Sigortası Alınır Mı?',
      content: [
        {
          paragraph:
            'Konut sigortası fiyatları kapsamına göre değişmektedir. En ucuz poliçe kapsamı en yüksek muafiyetli teminatlardan oluşmaktadır. Fiyat olarak ucuz olabilir, yalnız isteklerinize cevap alamadığınız takdirde poliçenin bir faydasını göremezsiniz.',
          subList: null
        },
        {
          paragraph:
            'Bu bağlamda en ucuz sigortayı almaktansa size en uygun teminatlı poliçeyi almanızı öneriyoruz. Poliçenizi satın alırken sadece primleri değil aynı zamanda teminatları da değerlendirmelisiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Konut Sigortası Fiyatları 2021 Ne Kadar?',
      content: [
        {
          paragraph:
            'Konut sigortası fiyatları aylık olarak şirket politikaları ve sunmuş olduğu teminatlara göre değişmektedir. Bu bağlamda net bir fiyat sunulamamaktadır.',
          subList: null
        },
        {
          paragraph:
            'Sigortalatmak istediğiniz ev için alokasko.com üzerinden başvuru formunu doldurabilirsiniz. Bilgilerinizi iletmeniz sonucunda uzman danışmanlarımız sizinle iletişime geçerek size özel hazırlanmış teklifleri sunacaktır.',
          subList: null
        }
      ]
    },
    {
      title: 'Konut Sigortasında Taksit Yapılıyor Mu?',
      content: [
        {
          paragraph:
            'Sigorta şirketleri kredi kartlarına 12 aya kadar vadeli bir şekilde poliçe tanzim etmektedir. Vade seçenekleri çalışmış olduğunuz ve sigorta şirketlerinin finansal politikalarına göre değişiklik göstermektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'En İyi Konut Sigortası Teklifi Nasıl Alınır?',
      content: [
        {
          paragraph:
            'Konut sigortası almak isteyen müşterilerimiz <strong>alokasko.com</strong> üzerinden başvuru formu doldurabilir veya <strong>0216 371 67 77</strong> numaralı hattan uzman danışmanlarımızla iletişime geçebilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Online Konut Sigortası Nasıl Alınır?',
      content: [
        {
          paragraph:
            'Günden güne ilerleme gösteren dijital ortamda konut sigortası poliçesi de satın almanız son derece kolay!',
          subList: null
        },
        {
          paragraph:
            'Online ev sigortası tekliflerini değerlendirmek ve poliçe satın almak için alokasko.com üzerinden başvuru formu doldurabilir veya 0216 371 67 77 numaralı hattan uzman danışmanımızla iletişime geçebilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'Konut sigortası talebinde bulunmanız durumunda alokasko ekibi sizinle iletişime geçerek siz değerli müşterilerimize özel hazırlanmış teklifi sunacaklardır. Sunulan teklifi değerlendirerek poliçe tanziminde bulunabilir, evinizi ve eşyalarınızı güvence altına alabilirsiniz.',
          subList: null
        }
      ]
    }
  ]
}
